import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function GameModes() {
  const [GameModes, setGameModes] = useState({
    left: [
      {
        title: "Arcade",
        subtitle: "Arcade",
        version: "1.20",
        count: 0,
        img: "./images/icon1.webp",
        boxShadow: "rgba(0,255,100,0.2)",
      },
      {
        title: "Survival",
        subtitle: "Survival",
        version: "1.21",
        count: 0,
        img: "./images/icon2.webp",
        boxShadow: "rgba(255,165,0,0.2)",
      },
      {
        title: "BedWars",
        subtitle: "BedWars",
        version: "1.8.9",
        count: 1298,
        img: "./images/icon3.webp",
        boxShadow: "rgba(128,0,128,0.2)",
      },
      {
        title: "Prison",
        subtitle: "Prison",
        version: "1.17",
        count: 0,
        img: "./images/icon4.webp",
        boxShadow: "rgba(135,206,235,0.2)",
      },
    ],
    right: [
      {
        title: "Skyblock",
        subtitle: "Skyblock",
        version: "1.20",
        count: 99,
        img: "./images/icon5.webp",
        boxShadow: "rgba(255,165,0,0.2)",
      },
      {
        title: "Oneblock",
        subtitle: "Oneblock",
        version: "1.20",
        count: 0,
        img: "./images/icon6.webp",
        boxShadow: "rgba(255,0,0,0.2)",
      },
      {
        title: "FFA",
        subtitle: "FFA",
        version: "1.20",
        count: 30,
        img: "./images/icon7.webp",
        boxShadow: "rgba(255,192,203,0.2)",
      },
      {
        title: "Practicepvp",
        subtitle: "Practicepvp",
        version: "1.8.9",
        count: 0,
        img: "./images/icon8.webp",
        boxShadow: "rgba(255,99,71,0.2)",
      },
    ],
  });
  return (
    <>
      <section className="px-4 relative z-10" id="GameModes">
        <div
          className="container md:pt-[140px] pt-10 relative z-20"
          style={{ direction: "rtl" }}
        >
          {/* image */}
          <div className="-mt-[210px] hidden md:flex justify-center relative z-0 pointer-events-none">
            <img src="./images/sword.webp" alt="" className="" />
          </div>
          {/* Main Container */}
          <div className="flex md:flex-row flex-col justify-between ">
            {/* Right Title */}
            <div className="flex flex-col items-center md:items-start pt-10 md:text-4xl text-xl text-white font-DanaDemiBold">
              <div className="flex justify-center md:justify-start">
                گیم مود های{" "}
                <span className="text-[#D4FE00] inline-flex flex-col gap-y-2">
                  تیرکس ماین{" "}
                  <svg
                    width={
                      typeof window !== "undefined" && window.innerWidth < 400
                        ? "100px"
                        : "216px"
                    }
                    height="24"
                    viewBox="0 0 216 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 15L58 3L46 20.5C69.6667 14.6667 169.9 3 213.5 3"
                      stroke="url(#paint0_linear_40_190)"
                      stroke-width="4"
                      stroke-linecap="round"
                    ></path>
                    <defs>
                      <linearGradient
                        id="paint0_linear_40_190"
                        x1="2.5"
                        y1="12"
                        x2="160.5"
                        y2="2.99993"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#D4FE00"></stop>
                        <stop offset="1" stop-color="#D4FE00"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
              </div>

              <p className="md:mt-[55px] mt-[20px] text-justify max-w-[622px] leading-7.5 text-base/[30px] md:text-lg text-[#828B97]">
                گیم‌مودهای تیرکس ماین یک جهان پر از تغییرات و افزونه‌های
                منحصربه‌فرد است که به بازی ماینکرفت شما ابعاد جدیدی اضافه
                می‌کنند. این گیم‌مودها می‌توانند تجربه بازی را به طور کامل تغییر
                دهند؛ از اضافه کردن قابلیت‌های جدید و تازه، بهبود دادن گرافیک،
                ایجاد دنیاهای جدید، یا حتی تغییر مکانیزم‌های بازی. هر گیم‌مود با
                الگوهای خاص و تأثیراتی که بر بازی دارد،.
              </p>
              <Link
                to="/more-about"
                className="inline-flex w-fit mt-5 px-5 py-2 bg-[#181B24] text-[#D1D1D1] text-base/[30px] rounded-md border border-zinc-800"
              >
                بیشتر بخوانید
              </Link>
            </div>
            {/* Left Gamemode Boxes */}
            <div className="relative mt-5 md:mt-0" style={{ direction: "ltr" }}>
              {/* Gamemode button */}
              <div className="grid md:grid-cols-2 grid-cols-1 gap-x-5 gap-y-5 ">
                {/* Left Colomun */}
                <div className="flex flex-col gap-y-5 z-10">
                  {GameModes.left &&
                    GameModes.left.map((item) => {
                      return (
                        <div
                          className="flex p-[14px] bg-[#181B24]/50 border border-zinc-700 rounded-lg items-center justify-between md:w-[300px] w-full transition duration-300 ease-in-out hover:shadow-[0_0_100px_rgba(0,255,100,0.1)] hover:[transform:perspective(1000px)_rotateY(20deg)_scale(1.05)]"
                          style={{}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = `0 0 100px ${item.boxShadow}`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = "";
                          }}
                        >
                          <div className="flex items-center gap-x-4">
                            <img src={item.img} alt="" className="rounded-lg" />
                            <div>
                              <h2 className="text-[#D1D1D1] font-DanaDemiBold text-lg">
                                {item.title}
                              </h2>
                              <h3 className="text-[#828B97]">
                                version : {item.version}
                              </h3>
                            </div>
                          </div>
                          {/* Right Side Button  */}
                          <div>
                            <div className="flex items-center justify-center text-white font-DanaDemiBold gap-x-1">
                              <span>2</span>
                              <div className="w-4 h-4 rounded-full bg-green-900 flex items-center justify-center">
                                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {/* Right Column */}
                <div className="flex flex-col gap-y-5 z-10">
                  {GameModes.right &&
                    GameModes.right.map((item) => {
                      return (
                        <div
                          className={`flex p-[14px] bg-[#181B24]/50 border border-zinc-700 rounded-lg items-center justify-between md:w-[300px] w-full transition duration-300 ease-in-out hover:[transform:perspective(1000px)_rotateY(-20deg)_scale(1.05)] ${
                            GameModes.shadowClass
                              ? `hover:${GameModes.shadowClass}`
                              : "hover:shadow-[0_0_100px_rgba(0,255,100,0.1)]"
                          }`}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = `0 0 100px ${item.boxShadow}`;
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = "";
                          }}
                        >
                          <div className="flex items-center gap-x-4">
                            <img src={item.img} alt="" className="rounded-lg" />
                            <div>
                              <h2 className="text-[#D1D1D1] font-DanaDemiBold text-lg">
                                {item.title}
                              </h2>
                              <h3 className="text-[#828B97]">
                                version : {item.version}
                              </h3>
                            </div>
                          </div>
                          {/* Right Side Button  */}
                          <div>
                            <div className="flex items-center justify-center text-white font-DanaDemiBold gap-x-1">
                              <span>2</span>
                              <div className="w-4 h-4 rounded-full bg-green-900 flex items-center justify-center">
                                <div className="w-2 h-2 rounded-full bg-green-400"></div>
                              </div>{" "}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>

              {/* image */}
              <div className="absolute z-0 flex md:-bottom-[180px] md:left-[55px] bottom-0 right-0 pointer-events-none">
                <img src="./images/hammer.webp" alt="" className="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
